import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/complete-profile")({
    component: () => <div>Hello /_auth/complete-profile!</div>,
});
